import { routePermissions } from "./routePermissions";

export const ADMIN_ONLY_ROUTES = new Set([
  "/page-access",
  "/steam_debug",
  "/admin/xbox",
  "/admin/tiktok",
  "/admin/youtube",
  "/admin/discord",
  "/admin/brand",
  "/admin/architecture/mindshare",
  "/admin/architecture/tiktok",
]);

// Available to every signed-in user, including users with no dashboard assignments.
// "/mindshare" is included so users without the mind-share permission still reach
// the dashboard, where a locked public preview (Top Growth + top 3 ranked games)
// renders instead of the full experience.
export const AUTHENTICATED_ROUTES = new Set(["/profile", "/logintest/game/:gameId", "/mindshare"]);

// Deny by default: non-admins only reach routes explicitly mapped to a permission they hold.
export function canAccessRoute(user, path) {
  if (!user) return false;
  if (user.is_admin) return true;
  if (ADMIN_ONLY_ROUTES.has(path)) return false;
  if (AUTHENTICATED_ROUTES.has(path)) return true;
  const permission = routePermissions[path];
  return Boolean(permission) && Array.isArray(user.permissions) && user.permissions.includes(permission);
}
